<template>
  <div
    class="page"
    :style="{
      'background-image': `url(${Bg})`,
      'background-position': 'center center',
      'background-repeat': 'no-repeat',
      'background-size': 'cover',
    }"
  >
    <el-row type="flex" align="middle" style="width: 100%" :gutter="100">
      <el-col
        v-if="showSliders"
        :span="14"
        style="display: flex; justify-content: end; flex-shrink: 0"
      >
        <Sliders />
      </el-col>
      <el-col
        :span="showSliders ? 10 : 24"
        style="display: flex"
        :style="{ 'justify-content': showSliders ? 'start' : 'center' }"
      >
        <div
          class="login-modal"
          :style="{ width: showSliders ? '533px' : '100%' }"
        >
          <div class="title">欢迎登录</div>
          <el-input
            v-model="username"
            class="form-input"
            placeholder="请输入账号"
            @blur.prevent="checkAdminPhone()"
          ></el-input>
          <el-input
            v-model="password"
            class="form-input"
            type="password"
            placeholder="请输入密码"
            @keyup.native.enter="login"
          ></el-input>

          <el-dialog
            title="短信校验"
            :visible.sync="dialogFormVisible"
            center
            class="el-dialog--small"
          >
            <el-input
              v-model="phone"
              class="col-margin-bottom"
              placeholder="请输入手机号"
            ></el-input>
            <el-row :gutter="18">
              <el-col>
                <span
                  ><el-input
                    v-model="phoneCode"
                    class="el-dialog-col--small"
                    placeholder="请输入手机验证码"
                  ></el-input
                ></span>
                <span v-if="smsphonestatus">
                  <el-button
                    type="primary"
                    class="code-btn"
                    :disabled="!show"
                    style="float: right; margin-bottom: 10px"
                    @click="sendsms()"
                  >
                    <span v-show="show">获取手机验证码</span>
                    <span v-show="!show" class="count">{{ count }} s</span>
                  </el-button>
                </span>
              </el-col>
              <el-col>
                <span
                  ><el-input
                    v-model="vcode"
                    class="el-dialog-col--small"
                    placeholder="请输图片验证码"
                  ></el-input
                ></span>
                <span @click="getVerify()">
                  <div style="float: right">
                    <img :src="url" class="captcha" />
                  </div>
                </span>
              </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
              <el-button
                style="margin-top: 10px"
                type="primary"
                :loading="loading"
                @click="loginpost"
                >确 定</el-button
              >
            </div>
          </el-dialog>
          <!--弹框：短信校验-->
          <el-dialog
            title="短信校验"
            :visible.sync="dialogFormVisible2"
            center
            class="el-dialog--small"
          >
            <div style="margin-bottom: 20px">
              <span style="font-size: medium"
                >短信验证码已发送到{{ phonefor }}</span
              >
            </div>
            <el-row :gutter="18" style="margin-bottom: 0px">
              <el-col :span="14">
                <el-input
                  v-model="phoneCode"
                  placeholder="请输入手机验证码"
                ></el-input>
              </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
              <el-button
                style="margin-top: 10px"
                type="primary"
                @click="loginpost"
                >确 定</el-button
              >
            </div>
          </el-dialog>
          <!--弹框：重置密码-->
          <el-dialog
            title="重置密码"
            :visible.sync="dialogFormVisible3"
            center
            class="el-dialog--small"
            :close-on-click-modal="false"
            show-close
          >
            <div style="margin-bottom: 20px">
              <span style="font-size: medium"
                >长期未修改密码或者第一次登录时需要重置密码</span
              >
            </div>
            <el-row :gutter="24" style="margin-bottom: 0px">
              <el-col :span="24">
                <el-input
                  v-model="username"
                  placeholder="请输入账号"
                ></el-input>
                <el-input
                  v-model="oldPassword"
                  show-password
                  placeholder="请输入旧密码"
                ></el-input>
                <el-input
                  v-model="newPassword"
                  show-password
                  placeholder="请输入新密码"
                ></el-input>
                <el-input
                  v-model="newPassword2"
                  show-password
                  placeholder="再次输入新密码"
                ></el-input>
                <div>
                  <span style="font-size: 12px"
                    >密码必须同时包含字母、数字、特殊字符，且长度在8~30之间</span
                  >
                </div>
              </el-col>
            </el-row>
            <div>
              <span style="font-size: 12px; color: red"
                >请勿将自己的账号密码提供给他人使用</span
              >
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button
                style="margin-top: 10px"
                type="primary"
                @click="resetPwd"
                >确 定</el-button
              >
            </div>
          </el-dialog>
          <!--弹框：提示-->
          <el-dialog
            :visible.sync="dialogExpiredVisible"
            center
            title="提示"
            class="el-dialog--small"
          >
            <span>{{ expiredMsg }}</span>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="handleExpiredCancel">取消</el-button>
                <el-button type="primary" @click="handleExpiredSubmit">
                  修改密码
                </el-button>
              </span>
            </template>
          </el-dialog>

          <el-button
            style="margin-top: 30px"
            :loading="loading"
            class="login-btn"
            :style="{ width: showSliders ? '471px' : '100%' }"
            @mousedown="checkAdminPhone()"
            @click="login"
            >登录</el-button
          >
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import md5 from "js-md5";
import Sliders from "./Sliders.vue";
import Bg from "../assets/img/login_bg.png";

const TIME_COUNT = 60;

export default {
  name: "Login",
  components: { Sliders },
  data() {
    return {
      dialogVisible: true,
      Bg,
      loading: false,
      username: "",
      password: "",
      oldPassword: "",
      newPassword: "",
      newPassword2: "",
      phone: "",
      vcode: "",
      phoneCode: "",
      imgVerify: this.getVerify(),
      url: `/erp/Admin/getVerify?d=${Math.random()}`,
      show: true,
      count: "",
      timer: null,
      dialogExpiredVisible: false,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      smsphonestatus: 0,
      phonefor: "",
      allowbrower: false,
      post_time: 0,
      viewportWidth: 0,
      expiredMsg: "",
    };
  },
  computed: {
    md5Pwd() {
      return md5(this.password);
    },
    showSliders() {
      return this.viewportWidth > 1200;
    },
  },
  created() {
    this.checkBrower();
  },
  mounted() {
    this.checkAdminPhone();
    this.viewportWidth = document.body.clientWidth;
    window.addEventListener("resize", this.getViewportWidth);
  },
  methods: {
    handleExpiredCancel() {
      this.loginpost();
      this.dialogExpiredVisible = false;
    },

    handleExpiredSubmit() {
      this.dialogFormVisible3 = true;
      this.dialogExpiredVisible = false;
    },

    getViewportWidth() {
      this.viewportWidth = document.body.clientWidth;
    },
    login() {
      if (!this.allowbrower) {
        // this.$message.error('请使用谷歌浏览器,火狐浏览器,chrome内核浏览器');
        // return ;
      }
      if (!this.password) {
        this.$message.error("密码不能为空");
        return;
      }
      if (this.smsphonestatus === 1 || this.smsphonestatus === 2) {
        this.loginpost();
      } else if (this.smsphonestatus === 3) {
        // 发送手机短信
        const url = "/erp/Admin/sendSmsByPwd";
        const args = {
          name: this.username,
          password: this.md5Pwd,
          login_type: "backend",
        };
        this.loading = true;
        this.$http
          .post(url, args)
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.dialogFormVisible2 = true;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (this.smsphonestatus === 4 || this.smsphonestatus === 5) {
        this.dialogFormVisible = true;
      } else if (this.smsphonestatus === 0) {
        if (this.post_time === 0) {
          // 谷歌浏览器自动填写表单 获取不到默认值时(无解),重新再提交一次
          this.loginpost();
          this.post_time += 1;
        } else {
          this.$message.error("登录账号/密码错误");
        }
      }
    },
    loginpost() {
      const args = {
        name: this.username,
        password: this.md5Pwd,
        login_type: "backend",
        phone: this.phone,
        phoneCode: this.phoneCode,
        returnUrl: this.$route.query.returnUrl || "",
      };
      this.loading = true;
      const url = "/erp/Admin/login";
      const _this = this;
      this.$http
        .post(url, args)
        .then((res) => {
          const { isHintExpiration = "", isResetPwd = "" } = res.data.data;
          if (res.data.code !== 200) {
            console.log("xx", res.data);
            /* 判断是否需要提示密码 */
            if (isHintExpiration) {
              this.expiredMsg = res.data.msg;
              this.dialogExpiredVisible = true;
            } else if (isResetPwd) {
              /* 判断是否需要重置密码 */
              this.dialogFormVisible3 = true;
            } else {
              /* 提示错误 */
              this.$message.error(res.data.msg);
            }
          } else {
            localStorage.setItem("userinfo", JSON.stringify(res.data.data));
            if (res.data.data.returnUrl) {
              window.location.href = res.data.data.returnUrl;
            } else if (this.$route.query.redirect) {
              console.log("redirect");
              _this.$router.replace({ path: `${this.$route.query.redirect}` });
              this.post_time = 0;
            } else {
              console.log("redirect to home");
              _this.$router.replace({ path: "/home" });
              this.post_time = 0;
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /* 提交重置密码 */
    resetPwd() {
      const args = {
        name: this.username,
        oldPassword: md5(this.oldPassword),
        newPassword: md5(this.newPassword),
        newPassword2: md5(this.newPassword2),
      };
      const url = "/erp/Admin/resetPwd";
      const _this = this;

      /* 判断密码是否一致 */
      if (
        this.username === "" ||
        this.oldPassword === "" ||
        this.newPassword === "" ||
        this.newPassword2 === ""
      ) {
        this.$message.error("请正确输入账号密码");
        return;
      }
      if (this.newPassword === this.oldPassword) {
        this.$message.error("新旧密码不能相同");
        return;
      }
      if (this.newPassword !== this.newPassword2) {
        this.$message.error("两次输入密码必须一致");
        return;
      }

      /* 判断密码复杂度 */
      const regex = /(?=.*[0-9])(?=.*[A-Za-z])(?=.*[^a-zA-Z0-9]).{8,30}/;
      if (!regex.test(this.newPassword)) {
        this.$message.error(
          "密码强度不够。密码中必须包含字母、数字、特殊字符，且长度大于8，小于30"
        );
      } else {
        this.$http.post(url, args).then((res) => {
          if (res.data.code !== 200) {
            /* 提示错误 */
            _this.$message.error(res.data.msg);
          } else {
            /* 提示成 */
            _this.$message.success("重置成功，请重新登录");
            this.dialogFormVisible3 = false;
          }
        });
      }
    },
    getVerify() {
      const url = "/erp/Admin/getVerify";
      this.url = `${url}?d=${Math.random()}`;
    },
    timecount() {
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count -= 1;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    sendsms() {
      if (!this.vcode) {
        this.$message.error("请输入图形验证码");
        return;
      }
      const url = "/erp/Admin/sendSms";
      const args = {
        phone: this.phone,
        vcode: this.vcode,
      };

      this.$http.post(url, args).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          this.getVerify();
        } else {
          this.$message.success(res.data.msg);
          this.timecount();
        }
      });
    },
    checkAdminPhone() {
      if (!this.username) {
        return;
      }
      const url = "/erp/Admin/checkPhoneSmsLogin";
      const args = {
        username: this.username,
      };
      this.$http.post(url, args).then((res) => {
        if (res.data.code === 200) {
          this.smsphonestatus = res.data.data.status;
          this.phone = res.data.data.mobile;
          if (res.data.data.mobile) {
            this.phoneformat();
          }
        }
      });
    },
    phoneformat() {
      const { phone } = this;
      this.phonefor = `${phone.substr(0, 3)}****${phone.substr(7)}`;
    },
    // 判断浏览器
    checkBrower() {
      // 取得浏览器的userAgent字符串
      const { userAgent } = navigator;
      // 判断是否允许的浏览器
      if (
        userAgent.indexOf("Chrome") > -1 ||
        userAgent.indexOf("Firefox") > -1
      ) {
        this.allowbrower = true;
      } else {
        this.$message.error("请使用谷歌浏览器,火狐浏览器,chrome内核浏览器");
      }
    },
  },
};
</script>

<style scoped>
.login-btn {
  width: 471px;
  height: 86px;
  background: linear-gradient(90deg, #cc3265, #ea3d8f);
  box-shadow: -1px 11px 29px 0px rgba(204, 50, 101, 0.19);
  border-radius: 43px;
  font-size: 33px;
  font-weight: 400;
  color: #ffffff;
  border: none;
}
.page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  /* padding-top: 200px; */
}
.form-input {
  margin-bottom: 29px !important;
}
.form-input >>> .el-input__inner {
  width: 100%;
  height: 85px;
  background: #ffffff;
  /* border: 2px solid #e27297; */
  border-radius: 8px;
  font-size: 26px;
  caret-color: #e27297;
  border: none;
}
.form-input >>> .el-input__inner:focus {
  border: 2px solid #e27297;
}
/* .el-input__inner {
  width: 190px;
  height: 500px;
} */
/*响应式布局*/
@media screen and (max-width: 600px) {
  .el-dialog--small {
    width: 380px !important;
    margin: auto;
  }
}

@media screen and (min-width: 800px) {
  .el-dialog--small {
    width: 800px !important;
    margin: auto;
  }
  .el-dialog-col--small {
    width: 56%;
  }
}

.login-modal {
  width: 533px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.title {
  width: 229px;
  height: 54px;
  font-size: 57px;
  font-weight: 400;
  color: #000000;
  line-height: 59px;
  margin-bottom: 40px;
}
.el-input {
  margin-bottom: 10px;
}
</style>
<style>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px #ffffff inset !important;
  box-shadow: 0 0 0px 1000px #ffffff inset !important;
}
input:-webkit-autofill::first-line {
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue